import { RotaModel } from 'model/app/master/autorizacao-rota';

export const RotasMock: RotaModel[] = [
    new RotaModel('/inicial'),
    new RotaModel('/importacao'),
    new RotaModel('/configuracoes'),
    new RotaModel('/remessa')
];
